module.exports = __webpack_public_path__ + "img/podcast.e9a35be6.png";